
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbLogWebHook extends AppService {

  abstract getAllWebhook(filter: AppFilter): Observable<any>;
  abstract getWebhook(id: number): Observable<any>;
}